import { i18n } from 'i18n';

export type EditProjectPageParams = Readonly<Record<'entityId', string | undefined>>;

export const ROUTE_PARAM_IDENTIFIER = ':entityId';
export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/overview/details/edit`;
export const TITLE = i18n._('Edit Project');
